// A component's browser tab title: a `meta()` option returning { title }, reactive like a computed.
//
//   meta() {
//     return { title: this.building ? `Kuunäidud - ${this.building.name}` : 'Kuunäidud' }
//   },
//
// The newest mounted component with a title shows; when it goes, the one before it does, then index.html's.
export default {
  install(app) {
    const fallback = document.title
    const titles = []
    const show = () => { document.title = titles.at(-1)?.title || fallback }

    app.mixin({
      created() {
        const meta = this.$options.meta
        if (typeof meta !== 'function') return
        const entry = { vm: this, title: '' }
        titles.push(entry)
        this.$watch(() => meta.call(this)?.title, (title) => {
          entry.title = title
          show()
        }, { immediate: true })
      },
      unmounted() {
        const i = titles.findIndex((e) => e.vm === this)
        if (i < 0) return
        titles.splice(i, 1)
        show()
      },
    })
  },
}
